import logEvent from "app/assets/javascripts/tracking/amplitude/log-event"
import { googletag } from "./shared"

const updateAdContainerStatus = (container, isFilled) => {
  if (isFilled) {
    container.className = "ad-container filled"
  } else {
    container.className = "ad-container unfilled"
  }
}

googletag.cmd.push(function () {
  googletag.pubads().addEventListener("slotRenderEnded", function (event) {
    const slot = event.slot
    const id = slot.getSlotElementId()
    const element = document.getElementById(id)
    if (element) {
      const container = document.getElementById(id).parentElement

      if (event.isEmpty && !container.classList.contains("filled")) {
        updateAdContainerStatus(container, false)
        logEvent("fallback_ad")
      } else {
        updateAdContainerStatus(container, true)
      }
    }
  })
})

setTimeout(() => {
  // If the ads haven't loaded after 2s, show the fallback
  const containers = document.querySelectorAll(".ad-container")
  if (googletag.apiReady) {
    return
  }

  for (let container of containers) {
    if (!container.classList.contains("filled")) {
      updateAdContainerStatus(container, false)
      logEvent("fallback_ad")
    }
  }
}, 2000)
